import React from 'react';
import {DatePicker, Space, Typography} from 'antd';
import dayjs from 'dayjs';

const RegistrationDateCondition = ({params, onChange}) => {
    return (
        <Space>
            <Typography.Text>가입일</Typography.Text>
            <DatePicker
                value={params.start ? dayjs.unix(params.start) : null}
                onChange={v => onChange({...params, start: v ? v.startOf('day').unix() : null})}
                showTime={{format: 'HH:mm'}}
                format="YYYY-MM-DD HH:mm"
                placeholder="시작일"
            />
            <Typography.Text>~</Typography.Text>
            <DatePicker
                value={params.end ? dayjs.unix(params.end) : null}
                onChange={v => onChange({...params, end: v ? v.endOf('day').unix() : null})}
                showTime={{format: 'HH:mm'}}
                format="YYYY-MM-DD HH:mm"
                placeholder="종료일"
            />
        </Space>
    );
};

export default RegistrationDateCondition;